import { locationIdFormat } from "@redotech/redo-ids/ids";
import { RedoFulfillmentToteGroupSchema } from "@redotech/redo-model/fulfillments/fulfillment-tote-group";
import * as z from "zod";

export const createToteGroup = {
  name: "createToteGroup" as const,
  input: z.object({ name: z.string(), locationId: locationIdFormat.schema }),
  output: RedoFulfillmentToteGroupSchema,
};
